// extracted by mini-css-extract-plugin
export default {"global_notice":"style_global_notice__LTZd6","global_notice_content":"style_global_notice_content__dlxNy","global_notice_text":"style_global_notice_text__ZP3ym"};